const dataFaqs = [
  {
    id: 1,
    title: " Who are our customers of TOY KI?",
    text: "오프라인에서 자신을 다른사람에게 표현하고, 연결되기를 원하는 모든사람들 입니다. 특히 100명 이상의 큰 그룹에 속해있으며, 집단에서 다양한 문화를 만들어 갈 수 있는 환경의 젊은 10,20대 사람들을 타겟으로 합니다. 이는 중고등학교 재학생 260만 명과 대학교 재학생의 일부 40만명으로 구성됩니다.",
    show: "",
  },
  {
    id: 2,
    title: " How does TOY KI connect with phones?",
    text: "TOY KI에 내장되어 있는 BLE 모듈을 기반으로 모바일 휴대폰과 연동됩니다. 각각의 장치들은 슬레이브 모드로 작동하며 모바일 휴대폰으로 검색 및 연동되어 정보를 주고받을 수 있습니다.",
    show: "",
  },
  {
    id: 3,
    title: " How big is the market?",
    text: "",
    show: "",
  },
  {
    id: 4,
    title: " Who are your main competitors?",
    text: "",
    show: "",
  },
  {
    id: 5,
    title: " What are the strengths of the TOY KI team?",
    text: "",
    show: "",
  },
  {
    id: 6,
    title: " How are TOY KI keyrings produced?",
    text: "",
    show: "",
  },
  {
    id: 7,
    title: " What other roles does the team require?",
    text: "",
    show: "",
  },
  {
    id: 8,
    title: "What are the benefits of joining our team?",
    text: "",
    show: "",
  },
];

export default dataFaqs;
